import { UserInitialsBadge } from '@dealstack/frontend/shared/components/UserInitialsBadge/UserInitialsBadge.tsx';
import { InitialsStatusBadgeStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsContent/components/InitialsStatusBadge/InitialsStatusBadge.styles.tsx';
import { InvestmentDetailsLegalDocumentSignerStatus } from '@dealstack/shared/lib/generated';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useMantineTheme } from '@mantine/core';

interface Props {
	firstName: string;
	lastName: string;
	status: InvestmentDetailsLegalDocumentSignerStatus;
}

export const InitialsStatusBadge = ({ firstName, lastName, status }: Props) => {
	const theme = useMantineTheme();

	const icon =
		status === InvestmentDetailsLegalDocumentSignerStatus.SIGNED ? (
			<Icon variant="circle-check" size="lg" color={theme.colors.teal[8]} />
		) : (
			<Icon variant="clock-time-watch" size="lg" color={theme.colors.orange[6]} />
		);

	return (
		<InitialsStatusBadgeStyles>
			<UserInitialsBadge
				firstName={firstName}
				lastName={lastName}
				size="md"
				textVariant="sm"
			/>

			<div className="icon">{icon}</div>
		</InitialsStatusBadgeStyles>
	);
};
